
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();
  const { t } = useLanguage();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Determine the correct home page based on authentication status
  const getHomePage = () => {
    if (!isAuthenticated) return "/";
    return "/agenda";
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center">
        <h1 className="text-6xl font-bold mb-4 text-primary">404</h1>
        <p className="text-xl text-gray-700 mb-6">
          {t("errors.page_not_found", "Oops! Page not found")}
        </p>
        <p className="text-gray-500 mb-8">
          {t(
            "errors.page_not_found_description",
            "The page you are looking for doesn't exist or you don't have permission to access it."
          )}
        </p>
        <Button 
          onClick={() => navigate(getHomePage())} 
          className="px-6 py-2"
        >
          {t("common.back_to_home", "Return to Home")}
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
